<template>
	<div
		v-if="is_mapeble"
		class="modal fade"
		ref="modal"
		data-backdrop="static"
	>
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title">
						MAPEAMENTO DE RISCOS - PPRA BÁSICO
					</h4>
				</div>
				<div class="modal-body no-padding">
					<ul class="nav nav-pills">
						<li
							@click="active = 'dados-tecnicos'"
							:class="active == 'dados-tecnicos' ? 'active' : ''"
						>
							<a>DADOS TÉCNICOS</a>
						</li>
						<li
							@click="active = 'map-antecipacao'"
							:class="active == 'map-antecipacao' ? 'active' : ''"
						>
							<a>ANTECIPAÇÃO</a>
						</li>
						<!-- <li @click='active="mapeamento"' :class="active == 'mapeamento' ? 'active' : '' ">
							<a>RECONHECIMENTO</a>
						</li>
						<li @click='active="ghe"' :class="active == 'ghe' ? 'active' : '' ">
							<a>GHE</a>
						</li>
						<li @click='active="epi"' :class="active == 'epi' ? 'active' : '' ">
							<a>EPI</a>
						</li> -->

						<li class="dropdown pull-right dropdown-rela-map">
							<a class="dropdown-toggle" data-toggle="dropdown">
								{{ map[sActive].setor }}
								<span class="caret"></span>
							</a>
							<ul class="dropdown-menu dropdown-menu-right">
								<li
									v-for="(item, id) in map"
									v-bind:key="id"
									@click="sActive = id"
									:class="{ active: id == sActive }"
								>
									<a>{{ item.setor }}</a>
								</li>
							</ul>
						</li>
					</ul>
					<div class="cnt-map">
						<!-- <pre>{{map}}</pre> -->
						<component :is="active" :dIn="dIn" @call="callback" />
					</div>
				</div>
				<div class="modal-footer">
					<div class="pull-lelt col-sm-3">
						<print-btn
							:data="row"
							loader="ordem_servico"
							no-title
						/>
					</div>
					<button
						type="button"
						class="btn btn-default"
						data-dismiss="modal"
					>
						Cancelar
					</button>
					<button
						class="btn btn-primary"
						:disabled="loading"
						@click="save_map"
					>
						<i v-if="!loading" class="fa fa-save"></i>
						<i v-else class="fa fa-spin fa-spinner"></i>
						Salvar
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import dadosTecnicos from './map-components/dados-tecnicos.vue';
	import mapAntecipacao from './map-components/antecipacao.vue';
	import mapeamento from './map-components/mapeamento.vue';
	import epi from './map-components/epi.vue';
	import ghe from './map-components/ghe.vue';

	import ResetDadosTecnicos from './js/reset.js';
	import cnaeCmp from './js/cnae_update.mixin.js';
	import WBS from 'js/http';
	import toastr from 'toastr';

	import printBtn from 'app/printBtn';

	export default {
		name: 'ModalMapeamentoRiscoBase',
		inject: ['row', 'assets', 'update'],
		mixins: [cnaeCmp],
		components: {
			printBtn,
			dadosTecnicos,
			mapAntecipacao,
			mapeamento,
			epi,
			ghe,
		},
		data() {
			return {
				active: 'dados-tecnicos',
				setores: [
					'ADMINISTRAÇÃO',
					'OPERAÇÃO',
					'APOIO',
					'EXTERNOS E OUTROS',
				],
				sActive: 0,
				enable: false,
				loading: false,
			};
		},
		computed: {
			dIn() {
				if (this.active == 'dados-tecnicos') {
					if (Array.isArray(this.row.contrato.dados_tecnicos))
						this.row.contrato.dados_tecnicos = ResetDadosTecnicos;
					return this.row.contrato.dados_tecnicos;
				} else {
					return this.row.contrato.mapeamento[this.sActive];
				}
			},
			total_func() {
				let total = 0;
				if (this.row.contrato.mapeamento != undefined) {
					this.row.contrato.mapeamento.forEach((map) => {
						if (map.funcoes != undefined) {
							map.funcoes.forEach((funcs) => {
								total +=
									parseInt(funcs.feminino) +
									parseInt(funcs.masculino);
							});
						}
					});
				}
				return total;
			},
			map() {
				return this.row.contrato.mapeamento;
			},
			is_mapeble() {
				return Array.isArray(this.map) && this.map.length != 0;
			},
		},
		methods: {
			save_map() {
				let sData = {
					cod: this.row.contrato.cod,
					dados_tecnicos: this.row.contrato.dados_tecnicos,
					mapeamento: this.row.contrato.mapeamento,
				};
				this.loading = true;

				WBS.send('protected-save-mapRisco', sData, (resp) => {
					this.loading = false;
					if (resp.status == 'success') {
						toastr.success('Salvo com sucesso!');
						// this.update()
					} else {
						toastr.error('Não foi possível salvar o contrato!');
						console.log(resp);
					}
				});
			},
			callback(fx) {
				try {
					this[fx.method](fx.payload);
				} catch (e) {
					console.log(
						'Erro ao axecutar a função "' + fx.method + '"',
						e
					);
				}
			},
			open() {
				console.log('...');
				if (this.assets.grau_de_risco != null) {
					this.enable = true;
					setTimeout((e) => {
						$(this.$refs.modal).modal('show');
					}, 100);
				} else {
					setTimeout(this.open, 100);
				}
			},
		},
	};
</script>
<style scoped>
	.dropdown-rela-map * {
		text-transform: uppercase;
	}
	.cnt-map {
		background: rgb(247, 247, 247);
		display: block;
		padding: 15px;
	}
	.modal-header,
	.modal-body {
		text-align: left;
	}
	ul.nav > li.active > a {
		background-color: #f7f7f7;
		color: #333;
	}
	.dropdown-toggle {
		color: #444 !important;
		background-color: #f7f7f7 !important;
	}
	/*.nav > li > a {color: #dedede;}		*/
	.nav a {
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/order-of-service/components/actions-components/mapeamento-risco.vue